import Page403 from "../pages/Page403";

export default [
  {
    path: "/403",
    name: "page403",
    component: Page403,
    meta: {
      layout: "auth"
    }
  },
];
